// extracted by mini-css-extract-plugin
export default {"f":"_73f1bc4fbf","main":"_114d742c96","btn":"f9fd303475","w":"_61117231da","h":"_707ea70648","lh25":"f4b917ef84","wb":"_255716ee6f","b":"_5c3d238aa3","bx":"b14221d0db"};